import React, { RefObject, useEffect, useLayoutEffect, useState } from "react";
import { DropdownItemProps } from "./types";
import { DropdownMatchesType } from "./constants";

const getContainerWidth = (ref: RefObject<HTMLDivElement>) => {
  const styles = ref && ref.current && window.getComputedStyle(ref.current);
  const getPadding = styles && parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
  const padding = getPadding ? getPadding : 0;
  return ref && ref.current && ref?.current.clientWidth - padding;
};

export const useDropdownPosition = (containerRef: React.Ref<HTMLDivElement>) => {
  const containerRefObject = containerRef as React.MutableRefObject<HTMLDivElement>;

  const [width, setWidth] = useState(getContainerWidth(containerRefObject));

  const handleResize = () => {
    setWidth(getContainerWidth(containerRefObject));
  };
  const handleClick = () => {
    /* setTimeout even with 0 timing only runs after current event has finished */
    setTimeout(() => {
      setWidth(getContainerWidth(containerRefObject));
    }, 0);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, [handleResize, width]);

  /* useLayoutEffect runs synchronously so paired with setTimeout this ensures that the width will recalculate after the filter has been pressed */
  useLayoutEffect(() => {
    handleClick();
  }, [handleClick]);

  return width;
};

export const selectedId = (item: DropdownItemProps, selector: DropdownMatchesType) => {
  switch (selector) {
    case DropdownMatchesType.TITLE:
      return item.title ? item.title : "";
    case DropdownMatchesType.SLUG:
      return item.slug ? item.slug : "";
    case DropdownMatchesType.ID:
      return item.id ? item.id : "";
    case DropdownMatchesType.UID:
      return item.uid ? item.uid : "";
    default:
      return "";
  }
};
